(() => {
  if (window.__ncEventBridgeReady) return;
  window.__ncEventBridgeReady = true;

  const approvedEventNames = new Set([
    'service_terms',
    'start_subscription',
    'view_model_product',
    'view_unlimited_plans',
    'view_pay_as_you_go',
    'apply_access',
    'request_test_account',
    'access_application_submit',
  ]);

  document.addEventListener('click', (event) => {
    const target = event.target?.closest?.('[data-nc-event]');
    if (!target || !approvedEventNames.has(target.dataset.ncEvent)) return;

    const detail = {
      event_name: target.dataset.ncEvent,
      page_path: location.pathname,
    };

    window.dispatchEvent(new CustomEvent('novcompute:event', { detail }));
  });
})();
